import { useState, useEffect } from "react";

/**
 * useState that persists to localStorage, so a page's filters/tab survive reloads and navigation.
 *
 *   const [tab, setTab] = useLocalStorageState("admin-orders:tab", "new");
 *
 * - `key` is namespaced under `edgelms:` automatically.
 * - Value is JSON-serialized; non-serializable values fall back to the default.
 * - Reads/writes are wrapped in try/catch so private-mode or quota errors never crash the page.
 */
export function useLocalStorageState(key, defaultValue) {
  const storageKey = `edgelms:${key}`;

  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      /* ignore write failures (private mode / quota) */
    }
  }, [storageKey, value]);

  return [value, setValue];
}

export default useLocalStorageState;
